import { reactive } from 'vue';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { default as Schema } from "async-validator";
import FormInput from "./form-input.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'contactForm',
  setup(__props) {
    const form = reactive({});
    const emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.(com|cn|net)$/;
    const phoneReg = /^[0-9\-]{7,13}$/;
    const descriptor = {
      name: {
        type: "string",
        required: true,
        message: "请输入姓名"
      },
      email: [{
        type: "string",
        required: true,
        message: "请输入邮箱   "
      }, {
        pattern: emailReg,
        message: "邮箱格式不正确"
      }],
      phone: [{
        type: "string",
        required: true,
        message: "请输入电话"
      }, {
        pattern: phoneReg,
        message: "电话格式不正确"
      }],
      nation: {
        type: "string",
        required: true,
        message: "请输入国家"
      },
      city: {
        type: "string",
        required: true,
        message: "请输入城市"
      },
      address: {
        type: "string",
        required: false
      },
      company: {
        type: "string",
        required: true,
        message: "请输入公司名称"
      },
      theme: {
        type: "string",
        required: true,
        message: "请输入您希望反馈的主题"
      },
      suggesstion: {
        type: "string",
        required: true,
        message: "请详细说明问题或建议"
      }
    };
    const validate = formData => {
      const validator = new Schema(descriptor);
      return new Promise((resolve, reject) => {
        validator.validate(formData, (errors, fields) => {
          if (errors) {
            reject(errors);
          }
          resolve(fields);
        });
      });
    };
    const submit = async () => {
      try {
        const data = await validate({
          ...form
        });
        console.log(data);
        // TODO: request api.
      } catch (error) {
        if (Array.isArray(error)) {
          var _error$;
          const message = (_error$ = error[0]) === null || _error$ === void 0 ? void 0 : _error$.message;
          ElMessage.error({
            message,
            grouping: true,
            offset: 130
          });
        }
      }
    };
    const clear = () => {
      for (const key in form) {
        delete form[key];
      }
    };
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "姓名",
            required: true,
            modelValue: _unref(form).name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).name = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "邮箱",
            required: true,
            modelValue: _unref(form).email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).email = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "电话",
            required: true,
            modelValue: _unref(form).phone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).phone = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "国家",
            required: true,
            modelValue: _unref(form).nation,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).nation = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "城市",
            required: true,
            modelValue: _unref(form).city,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).city = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "地址",
            required: false,
            modelValue: _unref(form).address,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).address = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "公司名称",
            required: true,
            modelValue: _unref(form).company,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).company = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "您希望反馈的主题是？",
            required: true,
            modelValue: _unref(form).theme,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(form).theme = $event),
            textarea: true
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(FormInput, {
            name: "请详细说明问题或建议？",
            required: true,
            modelValue: _unref(form).suggesstion,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).suggesstion = $event),
            textarea: true
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", {
        class: "btn-group"
      }, [_createElementVNode("button", {
        onClick: submit
      }, "提交"), _createElementVNode("button", {
        onClick: clear
      }, "清除")])]);
    };
  }
});